Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryAndMutation = exports.Mutation = exports.Query = exports.rootFieldTypes = void 0;
const registry_1 = require("./registry");
const error_1 = require("./error");
const Field_1 = require("../field/Field");
function validateRootSchemaField(targetInstance, fieldName) {
    if (!targetInstance[fieldName] &&
        !targetInstance.constructor.prototype[fieldName]) {
        throw new error_1.SchemaFieldError(targetInstance.constructor, fieldName, `Every root schema field must regular class function`);
    }
}
function requireSchemaRoot(target, fieldName) {
    if (registry_1.schemaRootsRegistry.has(target)) {
        return;
    }
    throw new error_1.SchemaFieldError(target, fieldName, `Root field must be registered on class decorated with @SchemaRoot`);
}
function getFieldCompiler(target, fieldName) {
    return () => {
        requireSchemaRoot(target, fieldName);
        return Field_1.compileFieldConfig(target, fieldName);
    };
}
var rootFieldTypes;
(function (rootFieldTypes) {
    rootFieldTypes["query"] = "query";
    rootFieldTypes["mutation"] = "mutation";
})(rootFieldTypes = exports.rootFieldTypes || (exports.rootFieldTypes = {}));
// special fields
function Query(options) {
    return (targetInstance, fieldName) => {
        validateRootSchemaField(targetInstance, fieldName);
        Field_1.Field({ rootFieldType: rootFieldTypes.query, ...options })(targetInstance, fieldName);
        const fieldCompiler = getFieldCompiler(targetInstance.constructor, fieldName);
        registry_1.queryFieldsRegistry.set(targetInstance.constructor, fieldName, fieldCompiler);
    };
}
exports.Query = Query;
function Mutation(options) {
    return (targetInstance, fieldName) => {
        validateRootSchemaField(targetInstance, fieldName);
        Field_1.Field({ rootFieldType: rootFieldTypes.mutation, ...options })(targetInstance, fieldName);
        const fieldCompiler = getFieldCompiler(targetInstance.constructor, fieldName);
        registry_1.mutationFieldsRegistry.set(targetInstance.constructor, fieldName, fieldCompiler);
    };
}
exports.Mutation = Mutation;
function QueryAndMutation(options) {
    return (targetInstance, fieldName) => {
        validateRootSchemaField(targetInstance, fieldName);
        Field_1.Field({ rootFieldType: rootFieldTypes.query, ...options })(targetInstance, fieldName);
        const fieldCompiler = getFieldCompiler(targetInstance.constructor, fieldName);
        registry_1.queryFieldsRegistry.set(targetInstance.constructor, fieldName, fieldCompiler);
        registry_1.mutationFieldsRegistry.set(targetInstance.constructor, fieldName, fieldCompiler);
    };
}
exports.QueryAndMutation = QueryAndMutation;
//# sourceMappingURL=rootFields.js.map